module.exports = __webpack_public_path__ + "react-public-static/media/logo.4a027e6b.png";